const html = `
<!-- Replace the whole <div class="article_block_item_img">…</div> with this -->
<svg class="article_block_item_img-svg"
     viewBox="0 0 1920 1080"  <!-- TODO: set to your real base image size -->
     width="100%" height="100%"
     preserveAspectRatio="xMidYMid slice"
     role="img" aria-label="Hero visual">

  <!-- Base image (background) -->
  <image
    href="/uploads/images/hero-s.webp"
    x="0" y="0" width="1920" height="1080"
    xlink:href="/uploads/images/hero-s.webp" />

  <!-- Cross overlay (initial frame of sequence or a static) -->
  <!-- TODO: set x/y/width/height to the exact placement you need -->
  <image id="cross-seq"
        x="800" y="460" width="400" height="400" 
         preserveAspectRatio="xMidYMid meet"
         href="/custom/images/animations-image-seq/cross/00.webp"
         xlink:href="/custom/images/animations-image-seq/cross/00.webp"
         style="pointer-events:none" />

  <!-- Crown overlay (initial frame of sequence or a static) -->
  <!-- Example positions; adjust to match your layout -->
  <image id="crown-seq"
        x="950" y="-280" width="600" height="600"
         preserveAspectRatio="xMidYMid meet"
         href="/custom/images/animations-image-seq/crown/00.webp"
         xlink:href="/custom/images/animations-image-seq/crown/00.webp"
         style="pointer-events:none" />
</svg>
`;

function buildSequences(svg, host) {
  const prefersReduced = typeof matchMedia === "function" && matchMedia("(prefers-reduced-motion: reduce)").matches;

  const crownEl = svg.querySelector("#crown-seq");
  const crossEl = svg.querySelector("#cross-seq");

  const crownSeq =
    crownEl &&
    window.makeImageSequence({
      target: crownEl,
      totalFrames: 50,
      fps: 36,
      mode: "once",
      basePath: "/custom/images/animations-image-seq/crown/",
      pad: 2,
      ext: "webp",
      paintInitial: false,
      initialFrame: 0,
    });

  const crossSeq =
    crossEl &&
    window.makeImageSequence({
      target: crossEl,
      totalFrames: 50,
      fps: 36,
      mode: "once",
      basePath: "/custom/images/animations-image-seq/cross/",
      pad: 2,
      ext: "webp",
      paintInitial: false,
      initialFrame: 0,
    });

  gsap.registerPlugin(ScrollTrigger);

  // 👇 If hero already played before (e.g. user resized),
  // just force everything into its final state and bail out.
  if (host.dataset.heroPlayed === "1") {
    // jump sequences to final frame
    crownSeq?.goto?.(49);
    crossSeq?.goto?.(49);

    // make sure text is in its final visible state
    gsap.set(".scene-1 h4", { opacity: 1 });
    gsap.set(".scene-1 p", { y: 0, opacity: 1 });

    return;
  }

  // 👇 First time only: create a single ScrollTrigger
  ScrollTrigger.create({
    trigger: svg,
    start: "top 70%",
    once: true,
    fastScrollEnd: true,
    anticipatePin: 1,
    onEnter: () => {
      if (prefersReduced) {
        crownSeq?.goto?.(49);
        crossSeq?.goto?.(49);
      } else {
        crownSeq?.play?.();
        crossSeq?.play?.();
      }

      animateSceneTextOnce(host);

      // mark as played so future resizes don't reset it
      host.dataset.heroPlayed = "1";
    },
  });
}

export function scene_1_hero() {
  const host = document.querySelector(".scene-1");
  if (!host) return;

  const wrap = host.querySelector(".article_block_item_img");
  if (!wrap) return;
  $(wrap).html(html);

  const svg = wrap.querySelector(".article_block_item_img-svg");
  if (!svg) return;

  svg.style.visibility = "hidden";

  const baseImageEl = svg.querySelector("image[href], image[xlink\\:href]");
  const baseSrc = baseImageEl?.getAttribute("href") || baseImageEl?.getAttribute("xlink:href");

  const baseImg = new Image();
  baseImg.decoding = "async";
  baseImg.onload = ready;
  baseImg.onerror = ready;
  if (baseSrc) baseImg.src = baseSrc;
  else ready();

  function ready() {
    svg.style.visibility = "";

    buildSequences(svg, host);

    if (window.gsap && window.gsap.ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);

      // optional: only refresh if hero hasn't played yet
      if (host.dataset.heroPlayed !== "1") {
        ScrollTrigger.refresh();
      }
    }
  }
}

function animateSceneTextOnce(host) {
  const isRM = typeof matchMedia === "function" && matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (host.dataset.heroAnimated) return;
  host.dataset.heroAnimated = "true";

  gsap.set(".scene-1 h4", { opacity: 1 });

  if (isRM) {
    gsap.to(".scene-1 p", {
      y: 0,
      opacity: 1,
      duration: 0.3,
      stagger: 0.04,
      ease: "power1.out",
    });
    return;
  }

  gsap.from(".scene-1 h4 .char", {
    opacity: 0,
    y: 10,
    duration: 0.02,
    stagger: 0.03,
    ease: "power1.out",
    onComplete: () => {
      gsap.to(".scene-1 p", {
        y: 0,
        opacity: 1,
        stagger: 0.05,
        duration: 0.5,
        ease: "power1.out",
      });
    },
  });
}
// ============================ CHANGED FOR MATCH MEDIA END . WORKING CODE BELOW BEFORE CHANGE

// export function scene_1_hero() {
//   const host = document.querySelector(".scene-1");
//   if (!host) return;

//   // 1) Inject SVG now
//   const wrap = host.querySelector(".article_block_item_img");
//   if (!wrap) return;
//   $(wrap).html(html); // your `html` string

//   // 2) Grab the freshly inserted SVG and parts
//   const svg = wrap.querySelector(".article_block_item_img-svg");
//   if (!svg) return;

//   // Hide SVG until base image is ready to avoid a flash
//   svg.style.visibility = "hidden";

//   // 3) Preload the base image the SVG <image> points to
//   const baseImageEl = svg.querySelector("image[href], image[xlink\\:href]");
//   const baseSrc = baseImageEl?.getAttribute("href") || baseImageEl?.getAttribute("xlink:href");

//   const baseImg = new Image();
//   baseImg.decoding = "async";
//   baseImg.onload = ready;
//   baseImg.onerror = ready;
//   if (baseSrc) baseImg.src = baseSrc;
//   else ready(); // nothing to wait for

//   function ready() {
//     // show svg after base is cached
//     svg.style.visibility = "";

//     // 4) Build sequences AFTER SVG exists in the DOM
//     buildSequences(svg, host);

//     // 5) If you use ScrollTrigger, refresh so it measures the new DOM
//     if (window.gsap && window.gsap.ScrollTrigger) {
//       gsap.registerPlugin(ScrollTrigger);
//       ScrollTrigger.refresh();
//     }

//     // (Optional) Your text reveal animation can start here too.
//   }
// }

// /* ———————————————— helpers ———————————————— */

// function buildSequences(svg, host) {
//   const prefersReduced = typeof matchMedia === "function" && matchMedia("(prefers-reduced-motion: reduce)").matches;

//   // elements inside the freshly inserted SVG
//   const crownEl = svg.querySelector("#crown-seq");
//   const crossEl = svg.querySelector("#cross-seq");

//   // Wire sequences (don’t autoplay; we’ll play on ScrollTrigger)
//   const crownSeq =
//     crownEl &&
//     window.makeImageSequence({
//       target: crownEl,
//       totalFrames: 50, // 00..49  (you had 48 by mistake)
//       fps: 36,
//       mode: "once",
//       basePath: "/custom/images/animations-image-seq/crown/",
//       pad: 2,
//       ext: "webp",
//       paintInitial: false, // keep whatever is in the markup (00)
//       initialFrame: 0,
//     });

//   const crossSeq =
//     crossEl &&
//     window.makeImageSequence({
//       target: crossEl,
//       totalFrames: 50, // set to your real cross count
//       fps: 36,
//       mode: "once",
//       basePath: "/custom/images/animations-image-seq/cross/",
//       pad: 2,
//       ext: "webp",
//       paintInitial: false,
//       initialFrame: 0,
//     });

//   // Trigger playback when the SVG scrolls into view

//   gsap.registerPlugin(ScrollTrigger);
//   ScrollTrigger.create({
//     trigger: svg,
//     start: "top 70%",
//     once: true,
//     fastScrollEnd: true,
//     anticipatePin: 1,
//     onEnter: () => {
//       if (prefersReduced) {
//         crownSeq?.goto?.(49);
//         crossSeq?.goto?.(49);
//         animateSceneTextOnce(host);
//       } else {
//         crownSeq?.play?.();
//         crossSeq?.play?.();
//         animateSceneTextOnce(host);
//       }
//     },
//   });
// }

// function animateSceneTextOnce(host) {
//   const isRM = typeof matchMedia === "function" && matchMedia("(prefers-reduced-motion: reduce)").matches;

//   if (host.dataset.heroAnimated) return;
//   host.dataset.heroAnimated = "true";

//   gsap.set(".scene-1 h4", { opacity: 1 });

//   if (isRM) {
//     gsap.to(".scene-1 p", { y: 0, opacity: 1, duration: 0.3, stagger: 0.04, ease: "power1.out" });
//     return;
//   }

//   // if you use SplitText, wire it here before this block
//   gsap.from(".scene-1 h4 .char", {
//     opacity: 0,
//     y: 10,
//     duration: 0.02,
//     stagger: 0.03,
//     ease: "power1.out",
//     onComplete: () => {
//       gsap.to(".scene-1 p", {
//         y: 0,
//         opacity: 1,
//         stagger: 0.05,
//         duration: 0.5,
//         ease: "power1.out",
//       });
//     },
//   });
// }

// code before changing videos to images
// ======================
// ======================

// ======================

// ======================

// ======================
// ======================
// ======================
// ======================
// ======================
// ======================
// ======================
// ======================

// import { wireVideoFallback } from "../common/wireVideoFallback";
// import { hardPrime } from "../common/hardPrimeVideo";
// function canPlay(type) {
//   const v = document.createElement("video");
//   return !!v.canPlayType && v.canPlayType(type).replace(/no/, "");
// }

// const supportsWebM = !!canPlay('video/webm; codecs="vp9,vorbis"') || !!canPlay('video/webm; codecs="vp8,vorbis"');
// const isIOSWebKit = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1); // iPadOS reports as Mac

// function awaitFirstFrame(video) {
//   if (!video) return Promise.resolve();
//   if ("requestVideoFrameCallback" in video) {
//     return new Promise((res) => video.requestVideoFrameCallback(() => res()));
//   }
//   if (video.readyState >= 2) return Promise.resolve();
//   return new Promise((res) => {
//     const on = () => {
//       video.removeEventListener("loadeddata", on);
//       video.removeEventListener("canplay", on);
//       res();
//     };
//     video.addEventListener("loadeddata", on, { once: true });
//     video.addEventListener("canplay", on, { once: true });
//     try {
//       video.load();
//     } catch {}
//   });
// }

// async function primeAndPlay(video) {
//   if (!video) return;
//   hardPrime(video);
//   try {
//     await video.play();
//   } catch {}
//   // don’t block on events; just ensure a frame gets decoded if possible
//   await awaitFirstFrame(video).catch(() => {});
// }

// export function scene_1_hero() {
//   const scene = document.querySelector(".scene-1");
//   if (!scene) return;

//   // ---- helpers you already have ----
//   // canPlay, awaitFirstFrame, hardPrime, primeAndPlay, wireVideoFallback ...

//   const isRM = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

//   function isSafari() {
//     const ua = navigator.userAgent;
//     const isSafariUA = /^((?!chrome|android).)*safari/i.test(ua);
//     const isIOSWK = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
//     return isSafariUA || isIOSWK;
//   }

//   // Lazily create & wire videos only once
//   let vids = null;
//   let appended = false;

//   function appendVideos() {
//     if (appended) return;
//     appended = true;

//     const baseStyle = "pointer-events:none;opacity:1;position:absolute;inset:0;z-index:3;";
//     const supportsWebM = !!canPlay('video/webm; codecs="vp9,vorbis"') || !!canPlay('video/webm; codecs="vp8,vorbis"');
//     const useWebM = supportsWebM && !isSafari();

//     const crossSources = useWebM
//       ? `
//          <source src="/custom/images/webm/cross-sm-2s.webm" type="video/webm">
//          <source src="/custom/images/webm/cross-sm-2s-safari.mov" type='video/mp4; codecs="hvc1"'>
//         `
//       : `
//          <source src="/custom/images/webm/cross-sm-2s-safari.mov" type='video/mp4; codecs="hvc1"'>
//         `;

//     const crownSources = useWebM
//       ? `
//          <source src="/custom/images/webm/crown-new-sm-2s.webm" type="video/webm">
//          <source src="/custom/images/webm/crown-new-sm-2s-safari.mov" type='video/mp4; codecs="hvc1"'>
//         `
//       : `
//          <source src="/custom/images/webm/crown-new-sm-2s-safari.mov" type='video/mp4; codecs="hvc1"'>
//         `;

//     const html = `
//       <video id="cross-hero" muted playsinline webkit-playsinline preload="auto" style="${baseStyle}">
//         ${crossSources}
//       </video>
//       <img class="video-fallback video-fallback--cross-hero" src="/custom/images/webm/covers/x.webp" alt="">

//       <video id="crown-hero" muted playsinline webkit-playsinline preload="auto" style="${baseStyle}">
//         ${crownSources}
//       </video>
//       <img class="video-fallback video-fallback--crown-hero" src="/custom/images/webm/covers/crown.webp" alt="">
//     `;

//     const imgWrap = scene.querySelector(".article_block_item_img");
//     if (imgWrap) {
//       imgWrap.style.position = "relative"; // stacking context
//       imgWrap.insertAdjacentHTML("beforeend", html);
//     }

//     const cross = scene.querySelector("#cross-hero");
//     const crown = scene.querySelector("#crown-hero");
//     const crossFB = scene.querySelector(".video-fallback--cross-hero");
//     const crownFB = scene.querySelector(".video-fallback--crown-hero");

//     wireVideoFallback(cross, crossFB);
//     wireVideoFallback(crown, crownFB);

//     vids = [cross, crown].filter(Boolean);
//     vids.forEach((v) => {
//       v.style.width = "100%";
//       v.style.height = "100%";
//       v.style.objectFit = "contain";
//       // Prepare attributes; do NOT force play yet
//       v.muted = true;
//       v.setAttribute("muted", "");
//       v.playsInline = true;
//       v.setAttribute("playsinline", "");
//       v.setAttribute("webkit-playsinline", "");
//       try {
//         v.currentTime = 0;
//       } catch {}
//     });
//   }

//   // Your text animation (once)
//   async function runAnimationOnce() {
//     if (scene.dataset.heroAnimated) return;
//     scene.dataset.heroAnimated = "true";

//     // Prime videos and show first frames (don’t block if it’s slow)
//     if (vids && vids.length && !isRM) {
//       await Promise.race([Promise.all(vids.map(primeAndPlay)), new Promise((res) => setTimeout(res, 800))]);
//     }

//     // const split = new SplitText(".scene-1 h4", { types: "chars" });
//     gsap.set(".scene-1 h4", { opacity: 1 });

//     // If reduced motion, just reveal quickly
//     if (isRM) {
//       gsap.set(split.chars, { opacity: 1 });
//       gsap.to(".scene-1 p", { y: 0, opacity: 1, duration: 0.3, stagger: 0.04, ease: "power1.out" });
//       return;
//     }

//     gsap.from(".scene-1 h4 .char", {
//       opacity: 0,
//       y: 10,
//       duration: 0.02,
//       stagger: 0.03,
//       ease: "power1.out",
//       onComplete: () => {
//         gsap.to(".scene-1 p", {
//           y: 0,
//           opacity: 1,
//           stagger: 0.05,
//           duration: 0.5,
//           ease: "power1.out",
//         });
//       },
//     });

//     // gsap.from(split.chars, {
//     //   opacity: 0,
//     //   duration: splitCharDur,
//     //   stagger: splitStagger,
//     //   ease: "none",
//     //   onComplete: () => {
//     //     gsap.to(".scene-1 p", {
//     //       y: 0,
//     //       opacity: 1,
//     //       stagger: 0.05,
//     //       duration: 0.5,
//     //       ease: "power1.out",
//     //     });
//     //   },
//     // });
//   }

//   // Play/pause policy when tab visibility changes (good hygiene)
//   document.addEventListener("visibilitychange", () => {
//     if (!vids) return;
//     if (document.hidden) vids.forEach((v) => v.pause?.());
//     else vids.forEach((v) => v.play?.().catch(() => {}));
//   });

//   // ===== ScrollTrigger wiring =====
//   gsap.registerPlugin(ScrollTrigger);

//   // Pre-warm slightly before enter so the videos are in the DOM
//   ScrollTrigger.create({
//     trigger: scene,
//     start: "top 85%", // when scene is near entering
//     once: true, // only once
//     onEnter: () => appendVideos(),
//   });

//   // Actually run the animation when nicely in view
//   ScrollTrigger.create({
//     trigger: scene,
//     start: "top 70%",
//     once: true,
//     fastScrollEnd: true,
//     // if you have a lot of pins above, a tiny anticipate helps
//     anticipatePin: 1,
//     onEnter: () => runAnimationOnce(),
//   });

//   // If you want to ensure videos pause when scrolled away:
//   ScrollTrigger.create({
//     trigger: scene,
//     start: "top bottom",
//     end: "bottom top",
//     onLeave: () => vids && vids.forEach((v) => v.pause?.()),
//     onEnterBack: () => vids && vids.forEach((v) => v.play?.().catch(() => {})),
//   });
// }
